import { SPage } from "servisofts-component";
import Model from "../../../Model";
import info_inversion from "./info_inversion";

//const model = Model.popup_inicio;
export const Parent = {
    name: "info_inversion",
    path: `/marketing/info_inversion`,
    //model
}
export default SPage.combinePages(Parent.name, {
    "": info_inversion,
})

